module.exports = __webpack_public_path__ + "static/media/worldcover_logo.1bb59eab.png";